export const RPMBillings = (function () {
	"use strict";

	// more than one id="person_details" div on the page? remove others
	document.addEventListener("DOMContentLoaded", function () {
		var elements = document.querySelectorAll('#person_details');
		elements.forEach(function (el, index) {
			if (index > 0) {
				el.parentNode.removeChild(el);
			}
		});
	});

	let mytap, castTabs;

	const doTab = (tabText) => {
		var allTabs = document.querySelectorAll(".cast-tabs .tab");

		// Activate the tab that matches the tabText
		allTabs.forEach(tab => {
			let tabTextContent = tab.textContent.toLowerCase();
			let tabTargets = document.querySelectorAll(`*[data-tab-target="${tab.textContent}"]`);

			if (tabTextContent.includes(tabText.toLowerCase())) {
				tab.classList.add("active"); // activate tab
				tabTargets.forEach(tabTarget => tabTarget.classList.add('active')); // activate all matching sections
				// Change the URL hash
				history.replaceState(null, null, `#${tab.id.split('-')[1]}`);
			} else {
				tab.classList.remove("active");
				tabTargets.forEach(tabTarget => tabTarget.classList.remove('active')); // deactivate all matching sections
			}
		});
	}

	const checkTabSituation = () => {
		let allTabs = castTabs.querySelectorAll(".tab");

		allTabs.forEach(function (tab) {
			tab.addEventListener("click", function (event) {
				doTab(this.textContent);
			});
		});

		// Set initial state based on URL hashtag or first tab, depending
		var firstTabText = allTabs[0].textContent;
		var currentURL = window.location.href;
		if (currentURL.indexOf("#") !== -1) {
			var hashtagValue = currentURL.substring(currentURL.indexOf("#") + 1);
			if (checkIfTabExists(hashtagValue)) {
				doTab(hashtagValue);
			} else {
				doTab(firstTabText);
			}
		} else {
			doTab(firstTabText);
		}
	}

	const init = () => {
		mytap = window.ontouchstart === null ? "touchstart" : "click";
		// If there is a div on the page with the tabs on it, run the function to hide all/show one
		castTabs = document.querySelector(".cast-tabs");
		if (castTabs) {
			checkTabSituation();
		}
		// If there is onlye one tab, do the hide/show (above) but then hide the tab itself.
		if ($('.cast-tabs ul li').length === 1) {
			$('.cast-tabs').hide();
		}
	}

	const checkIfTabExists = (hashtagValue) => {
		return Array.from(document.querySelectorAll('.cast-tabs .tab')).some(tab =>
			tab.id.toLowerCase().includes(hashtagValue.trim().toLowerCase())
		);
	}

	return {
		init: init,
	};
})();
